import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo10 } from "../../../routes/Module10";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo10/conferencia.png";
import Imagen2 from "../../../images/modulo10/paisanos.png";
import Imagen3 from "../../../images/modulo10/negociado.png";
import Imagen4 from "../../../images/modulo10/votolicencia.png";
import Imagen5 from "../../../images/modulo10/fiscalizacion.png";
import Imagen6 from "../../../images/modulo10/cerrarescuela.png";
import GuiaDocente from "../../../components/GuiaDocente";
import InputRadioButton from "../../../components/InputRadioButton";
import Card from "../../../components/Card";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo10/Actividad 4.mp3";

const Actividad4 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "option1" },
    ans2: { value: "", valid: "", correctValue: "option2" },
    ans3: { value: "", valid: "", correctValue: "option1" },
  });
  const infoUnidad = modulo10.content[0];
  const infoAct = modulo10.content[0].activities[3];
  const crumbs = [
    {
      title: modulo10.title,
      url: "/" + modulo10.url,
    },
    {
      title:
        modulo10.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo10.content[0].activities[4].name}`,
    linkNext: `${modulo10.url}/${modulo10.content[0].path}/${modulo10.content[0].activities[4].path}`,
    titlePrev: `${modulo10.content[0].activities[2].name}`,
    linkPrev: `${modulo10.url}/${modulo10.content[0].path}/${modulo10.content[0].activities[2].path}`,
  };

  const metadata = {
    color: modulo10.color,
    title: `${modulo10.title} - ${infoAct.name}`,
    name: modulo10.title,
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"] === answers[key]["value"]
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };
  const handleAnswer = (label, value) => {
    setAnswers({
      ...answers,
      [label]: { ...answers[label], value },
    });
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo10.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <ul>
        <li>Observa las siguientes viñetas.</li>
        <li>
          En cada caso, marca la que te parezca que expresa mejor las funciones
          del Congreso.
        </li>
      </ul>

      <h5 className="text-center mt-5">Representar</h5>
      <div className="row ms-md-3">
        <div className="col-md-6 col-12">
          <Card>
            <InputRadioButton
              ans={answers.ans1}
              label="ans1"
              value="option1"
              text=""
              handleAnswer={handleAnswer}
            />
            <img src={Imagen1} alt="Grupo de personas" className="img-fluid" />
          </Card>
        </div>
        <div className="col-md-6 col-12">
          <Card>
            <InputRadioButton
              ans={answers.ans1}
              label="ans1"
              value="option2"
              text=""
              handleAnswer={handleAnswer}
            />
            <img src={Imagen2} alt="Grupo de personas" className="img-fluid" />
          </Card>
        </div>
      </div>

      <h5 className="text-center mt-5">Legislar</h5>
      <div className="row ms-md-3">
        <div className="col-md-6 col-12">
          <Card>
            <InputRadioButton
              ans={answers.ans2}
              label="ans2"
              value="option1"
              text=""
              handleAnswer={handleAnswer}
            />{" "}
            <img src={Imagen3} alt="Grupo de personas" className="img-fluid" />
          </Card>
        </div>
        <div className="col-md-6 col-12">
          <Card>
            <InputRadioButton
              ans={answers.ans2}
              label="ans2"
              value="option2"
              text=""
              handleAnswer={handleAnswer}
            />{" "}
            <img src={Imagen4} alt="Grupo de personas" className="img-fluid" />
          </Card>
        </div>
      </div>

      <h5 className="text-center mt-5">Fiscalizar</h5>
      <div className="row ms-md-3">
        <div className="col-md-6 col-12">
          <Card>
            <InputRadioButton
              ans={answers.ans3}
              label="ans3"
              value="option1"
              text=""
              handleAnswer={handleAnswer}
            />{" "}
            <img src={Imagen5} alt="Grupo de personas" className="img-fluid" />
          </Card>
        </div>
        <div className="col-md-6 col-12">
          <Card>
            <InputRadioButton
              ans={answers.ans3}
              label="ans3"
              value="option2"
              text=""
              handleAnswer={handleAnswer}
            />{" "}
            <img
              src={Imagen6}
              alt="Grupo de personas"
              className="img-fluid mb-4"
            />
          </Card>
        </div>
      </div>
      <div className="row my-4">
        <div className="col-md-12">
          <button
            className={`btn float-end btn-${modulo10.color}`}
            onClick={validateAnswers}
          >
            Enviar respuestas
          </button>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones y las viñetas. Explique que aparecen las tres
          funciones del Congreso: representar, legislar y fiscalizar. Para cada
          una de las funciones hay dos situaciones. Deberán marcar la opción que
          mejor expresa la función señalada y que beneficia a todos
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad4;
